const PestControlData = [
  {
    id: 1,
    title: "General Pest Control",
    image: "/assets/pestControll/All Pest Control Services.jpg",
    image2: "/assets/pestControll/Pest Control Services2.jpg",
    image3: "/assets/pestControll/Pest Control Services3.webp",
    shortDescription: "Comprehensive pest control for a pest-free environment.",
    description:
      "Our General Pest Control service is tailored to address common household pests, ensuring your home or office remains pest-free. Using safe and effective methods, we eliminate pests like ants, spiders, and more. Our team conducts a thorough inspection to identify problem areas and applies targeted treatments to provide long-lasting results.",
    description1:
      "We use eco-friendly and family-safe solutions to tackle pests without causing harm to the environment or your loved ones. Our team is trained to handle various pest infestations with precision and care, ensuring minimal disruption to your daily routine. Whether it's a one-time service or ongoing maintenance, we are here to help.",
    description2:
      "Our service includes treatments for cracks, crevices, and entry points to prevent future infestations. We also provide recommendations to maintain a pest-free environment. With our experience and commitment to quality, you can trust us to keep your property safe and comfortable.",
    benefits: [
      "Effective pest elimination.",
      "Safe for families and pets.",
      "Eco-friendly solutions.",
      "Long-term prevention strategies.",
      "Experienced and professional team.",
      "Flexible service plans available.",
    ],
  },
  {
    id: 2,
    title: "Bad Bugs Pest Control",
    image: "/assets/pestControll/Bad Bugs Pest Control2.webp",
    image2: "/assets/pestControll/Bad Bugs Pest Control1.jpg",
    image3: "/assets/pestControll/Bad Bugs Pest Control3.webp",
    shortDescription: "Eliminating bad bugs with precision and care.",
    description:
      "Our Bad Bugs Pest Control service targets stubborn pests like bed bugs and mites. These pests can cause discomfort and health issues, which is why our team uses advanced techniques to eradicate them effectively. With our expertise, we ensure a pest-free and comfortable living or working space.",
    description1:
      "We focus on identifying the source of the infestation and apply treatments that provide immediate relief. Our solutions are safe for humans and pets while being highly effective against pests. From inspection to follow-up treatments, we handle every step with care.",
    description2:
      "Our service includes detailed inspections to locate hiding spots and targeted treatments for maximum effectiveness. We also provide preventive measures to avoid future infestations. Trust our experienced team to handle bad bugs efficiently and safely.",
    benefits: [
      "Eradicates stubborn pests.",
      "Immediate relief from infestations.",
      "Safe and effective solutions.",
      "Targeted treatments for high success rates.",
      "Professional inspections included.",
      "Preventive measures for long-term results.",
    ],
  },
  {
    id: 3,
    title: "Termite Pest Control",
    image: "/assets/pestControll/Termite Pest Control1.webp",
    image2: "/assets/pestControll/Termite Pest Control4.jpg",
    image3: "/assets/pestControll/Termite Pest Control3.jpg",
    shortDescription: "Protecting your property from destructive termites.",
    description:
      "Our Termite Pest Control service is designed to safeguard your home or office from termite damage. Using advanced treatment methods, we eliminate termite colonies and prevent their return. Our team conducts thorough inspections to assess the extent of infestation and applies treatments accordingly.",
    description1:
      "We use safe and effective termite control solutions that protect your property while being environmentally friendly. From pre-construction treatments to post-infestation management, we offer comprehensive termite control services tailored to your needs.",
    description2:
      "Our service includes detailed inspections, barrier treatments, and monitoring systems to ensure long-term protection. With years of experience, we guarantee effective termite control and peace of mind for your property.",
    benefits: [
      "Eliminates termite colonies.",
      "Prevents future infestations.",
      "Environmentally friendly solutions.",
      "Comprehensive protection plans.",
      "Highly experienced professionals.",
      "Long-lasting results for your property.",
    ],
  },
  {
    id: 4,
    title: "Mosquito Pest Control",
    image: "/assets/pestControll/Mosquito Pest Control.jpg",
    image2: "/assets/pestControll/Mosquito Pest Control2.webp",
    image3: "/assets/pestControll/Mosquito Pest Control3.webp",
    shortDescription: "Breathe easy with our mosquito control services.",
    description:
      "Our Mosquito Pest Control service ensures a mosquito-free environment, allowing you to enjoy your space without worries. We use advanced spraying techniques and safe repellents to reduce mosquito populations effectively. Our team identifies breeding sites and applies targeted treatments for long-term relief.",
    description1:
      "We prioritize the safety of your family and pets by using eco-friendly products. Our mosquito control measures are tailored to suit both indoor and outdoor areas, ensuring comprehensive protection. Regular follow-ups ensure that your space remains mosquito-free.",
    description2:
      "Our service includes identifying and treating mosquito breeding grounds, applying safe repellents, and providing tips for maintaining a mosquito-free environment. Let our experts handle your mosquito problems with guaranteed results.",
    benefits: [
      "Effective mosquito reduction.",
      "Safe and eco-friendly solutions.",
      "Targets breeding sites for lasting relief.",
      "Comprehensive indoor and outdoor coverage.",
      "Experienced and reliable team.",
      "Regular follow-up treatments available.",
    ],
  },
  {
    id: 5,
    title: "Cockroach Pest Control",
    image: "/assets/pestControll/Cockroach Pest Control.png",
    image2: "/assets/pestControll/Cockroach Pest Control2.jpeg",
    image3: "/assets/pestControll/Cockroach Pest Control3.jpeg",
    shortDescription: "Say goodbye to cockroaches with our expert services.",
    description:
      "Our Cockroach Pest Control service targets cockroaches using safe and effective methods. These pests are known for spreading diseases, and our team ensures their complete removal from your property. We apply targeted treatments to eliminate existing infestations and prevent future occurrences.",
    description1:
      "We use safe and eco-friendly solutions to tackle cockroach problems effectively. Our trained professionals conduct thorough inspections to identify and treat infested areas with precision. Whether it's a residential or commercial property, we provide tailored services to meet your needs.",
    description2:
      "Our service includes identifying cockroach hiding spots, applying effective treatments, and sealing entry points to prevent reinfestation. With our expertise, we ensure a cockroach-free and hygienic space for you and your family.",
    benefits: [
      "Complete removal of cockroaches.",
      "Prevents reinfestation.",
      "Safe and eco-friendly treatments.",
      "Tailored solutions for every property.",
      "Professional and reliable team.",
      "Hygienic and pest-free environment.",
    ],
  },
];

export default PestControlData;
